var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-wrapper o-wrapper--center"},[_c('div',{staticClass:"o-page"},[_c('main',{staticClass:"o-main"},[_vm._t("main")],2),_vm._v(" "),_c('aside',{staticClass:"o-sidebar-left"},[_vm._t("sidebar-left")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7885f8bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarLeft.vue
// module id = yX3Q
// module chunks = 1